import { render, staticRenderFns } from "./ProductHuntBadge.vue?vue&type=template&id=7721e0ec&scoped=true&"
import script from "./ProductHuntBadge.vue?vue&type=script&lang=ts&"
export * from "./ProductHuntBadge.vue?vue&type=script&lang=ts&"
import style0 from "./ProductHuntBadge.vue?vue&type=style&index=0&id=7721e0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7721e0ec",
  null
  
)

export default component.exports